define('WeltPixel_ProductPage/js/product-payment',[
    "jquery"
], function($){
        "use strict";
        return function(config, element) {
            setTimeout( function () {
                // var style = document.createElement( 'style' )
                // style.innerHTML = '.amazonpay-button-view3 { display: none; } ' +
                //                   '.amazonpay-button-container { max-width: 200px; }'
                // document.getElementById('ui-id-46').shadowRoot.appendChild( style )
            }, 1000);
        }
    }
)
;
